import { FirestoreService } from '../../../sdk/firestoreService';
import { fetchLicense, fetchPlanDefinitions, fetchActivePromotion, fetchAdminUids } from '../../../store/actions/licenseActions';

// Action Creators
export const fetchUserProfileStart = () => ({
  type: 'FETCH_USER_PROFILE_START'
});

export const fetchUserProfileSuccess = (user) => ({
  type: 'FETCH_USER_PROFILE_SUCCESS',
  payload: { user }
});

export const fetchUserProfileFailure = (error) => ({
  type: 'FETCH_USER_PROFILE_FAILURE',
  payload: error
});

export const updateUserSuccess = (userData) => ({
  type: 'UPDATE_USER_SUCCESS',
  payload: userData
});

// Thunk Actions
export const fetchUserProfile = (firebaseUser) => async (dispatch) => {
  dispatch(fetchUserProfileStart());

  try {
    console.log('Fetching user profile for:', firebaseUser.uid);
    let user = await FirestoreService.getUserProfile(firebaseUser.uid);

    // If user doesn't exist, create new user
    if (!user) {
      console.log('User not found, creating new user');
      const newUserData = {
        email: firebaseUser.email,
        displayName: firebaseUser.displayName,
        photoURL: firebaseUser.photoURL,
        role: 'OWNER',
        createdAt: new Date()
      };
      user = await FirestoreService.createUser(firebaseUser.uid, newUserData);
    } else {
      console.log('Existing user found:', user);
    }

    dispatch(fetchUserProfileSuccess(user));

    // טעינת נתוני רישיון — תמיד
    dispatch(fetchPlanDefinitions());
    dispatch(fetchActivePromotion());
    dispatch(fetchAdminUids());
    if (user.organizationId) {
      dispatch(fetchLicense(user.organizationId));
    }
  } catch (error) {
    console.error('Error fetching user profile:', error);
    dispatch(fetchUserProfileFailure('Failed to load user profile'));
  }
};